import { Link } from 'react-router-dom';
import EmisionGuiaV3Module from '@/modules/guias/EmisionGuiaV3.jsx';

export default function EmisionGuiaV3() {
  return (
    <div className="space-y-3">     
      <EmisionGuiaV3Module />
    </div>
  );
}
